import { Loader2 } from 'lucide-react'
import React from 'react'

function Loader() {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '60vh',
            }}
        >
            <Loader2
                size={48}
                color="#33bdbf"
                style={{
                    animation: 'spin 1s linear infinite',
                    filter: 'drop-shadow(0 0 6px rgba(51, 189, 191, 0.51))',
                    transform: 'scale(1.1)',
                }}
            />
        </div>
    )
}

export default Loader
